var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ResourceBoxes from '../resource-box/resource-boxes';
import { FormattedMessage } from 'react-intl';
import './featured-resources.scss';
function FeaturedResources(_a) {
    var { header, models } = _a, props = __rest(_a, ["header", "models"]);
    const modResources = models.map((res) => {
        const storageKey = `featured-resource-${res.heading}`;
        const seenTimes = 1 + Number(window.localStorage[storageKey] || 0);
        const model = Object.assign({
            isNew: seenTimes <= 3
            // There was an onClick defined here that nothing used
        }, res);
        window.localStorage[storageKey] = seenTimes;
        return model;
    });
    return (React.createElement("div", { className: "card" },
        React.createElement("div", { className: "headline" }, header),
        React.createElement("div", { "data-analytics-content-list": props['data-analytics-content-list'], className: "resources" },
            React.createElement(ResourceBoxes, { models: modResources }))));
}
export default function FeaturedResourcesSection(_a) {
    var { header, models } = _a, props = __rest(_a, ["header", "models"]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "featured-resources" },
            React.createElement(FeaturedResources, Object.assign({ header: header, models: models }, props))),
        React.createElement("div", { className: "divider" },
            React.createElement("div", { className: "line" }),
            React.createElement(FormattedMessage, { id: "resources.additional", defaultMessage: "see additional resources below" }),
            React.createElement("div", { className: "line" }))));
}
